import {
  DriverMetricAdjustmentsService,
  type DriverMetricAdjustmentMetricType,
  type DriverMetricAdjustmentStatus,
  type Pagination1OfDriverMetricAdjustmentAdminDto,
  type SearchDriverStatus
} from '@/backend/market'
import type { CancelablePromise } from '@/backend/market/core/CancelablePromise'
import { OpenAPI } from '@/backend/market/core/OpenAPI'
import { request as requestApi } from '@/backend/market/core/request'

/**
 * The generated list client cannot be used here because the shared request core
 * rewrites every YYYY-MM-DD query value into an ISO timestamp. `recordDate` is
 * a DateOnly value, so the query is embedded in the URL and stays untouched.
 */
export class DriverMetricAdjustmentsApi {
  static getAdjustments(params: {
    driverId?: number
    regionId?: number
    metricType?: DriverMetricAdjustmentMetricType
    status?: DriverMetricAdjustmentStatus
    recordDate?: string
    page?: number
    limit?: number
  }): CancelablePromise<Pagination1OfDriverMetricAdjustmentAdminDto> {
    const query = new URLSearchParams()

    if (params.driverId !== undefined) query.set('driverId', String(params.driverId))
    if (params.regionId !== undefined) query.set('regionId', String(params.regionId))
    if (params.metricType) query.set('metricType', params.metricType)
    if (params.status) query.set('status', params.status)
    if (params.recordDate) query.set('recordDate', params.recordDate)
    if (params.page !== undefined) query.set('page', String(params.page))
    if (params.limit !== undefined) query.set('limit', String(params.limit))

    const queryString = query.toString()
    return requestApi(OpenAPI, {
      method: 'GET',
      url: `/api/admin/v1/drivermetricadjustments${queryString ? `?${queryString}` : ''}`,
      errors: {
        401: 'Unauthorized',
        403: 'Forbidden'
      }
    })
  }

  static getAdjustment(id: string) {
    return DriverMetricAdjustmentsService.getAdjustmentAdmin({ id })
  }

  static revokeAdjustment(id: string, reason: string) {
    return DriverMetricAdjustmentsService.postRevokeAdjustmentAdmin({
      id,
      requestBody: { reason }
    })
  }

  static createAcceptanceAdjustment(data: {
    searchDriverId: string
    effectiveStatus: SearchDriverStatus
    reason: string
    idempotencyKey: string
  }) {
    return DriverMetricAdjustmentsService.postAcceptanceAdjustmentAdmin({ requestBody: data })
  }

  static createShiftAdherenceAdjustment(data: {
    driverShiftId: string
    startAt: string
    endAt: string
    reason: string
    idempotencyKey: string
  }) {
    return DriverMetricAdjustmentsService.postShiftAdherenceAdjustmentAdmin({ requestBody: data })
  }
}
